/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesCurrentUser.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Current User Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:58 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const CurrentUserProfile = Loadable({
    loader: () => import('../containers/CurrentUserProfile/CurrentUserProfileEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesCurrentUser.js